export interface ReserveSettings {
  inheritAgencyReserveRate: boolean
  reserveRate: number
}

export enum AgencyReserveType {
  None = 'None',
  AgencyPurchaser = 'AgencyPurchaser',
  CustomerPurchaser = 'CustomerPurchaser'
}
